import { RoadTrain, Vehicle } from '@common/types';

export const roadTrain2table = (roadTrains: Array<RoadTrain>, filterID?: Vehicle['ID']) => {
  return roadTrains.filter((train) => train.VehicleID === filterID);
};
